import {
  UPDATE_GLOBAL_STATE,
} from 'actions';

export const updateGlobalState = (payload) => ({
  type: UPDATE_GLOBAL_STATE,
  payload,
});
